import { WorkflowRole } from '@exam-management/common/types';
import { QuestionReviewWorkflowStepCode } from '@exam-management/task-management';

export enum QuestionReviewResultVariant {
  HIDDEN = 'HIDDEN',
  READONLY = 'READONLY',
  EDITABLE = 'EDITABLE',
}

export const variant = {
  [WorkflowRole.TASK_OWNER]: {
    [QuestionReviewWorkflowStepCode.QuestionReviewTodo]: QuestionReviewResultVariant.HIDDEN,
    [QuestionReviewWorkflowStepCode.QuestionReviewInReview]: QuestionReviewResultVariant.READONLY,
    [QuestionReviewWorkflowStepCode.QuestionReviewReviewed]: QuestionReviewResultVariant.READONLY,
    [QuestionReviewWorkflowStepCode.QuestionReviewDone]: QuestionReviewResultVariant.READONLY,
  },
  [WorkflowRole.TASK_ASSIGNEE]: {
    [QuestionReviewWorkflowStepCode.QuestionReviewTodo]: QuestionReviewResultVariant.EDITABLE,
    [QuestionReviewWorkflowStepCode.QuestionReviewInReview]: QuestionReviewResultVariant.EDITABLE,
    [QuestionReviewWorkflowStepCode.QuestionReviewReviewed]: QuestionReviewResultVariant.READONLY,
    [QuestionReviewWorkflowStepCode.QuestionReviewDone]: QuestionReviewResultVariant.READONLY,
  },
};

export default function getQuestionReviewResultVariant(
  roles: { isOwner: boolean; isAssignee: boolean },
  QuestionReviewWorkflowStepCode: QuestionReviewWorkflowStepCode,
) {
  if (roles.isAssignee) {
    return variant[WorkflowRole.TASK_ASSIGNEE][QuestionReviewWorkflowStepCode];
  }

  if (roles.isOwner) {
    return variant[WorkflowRole.TASK_OWNER][QuestionReviewWorkflowStepCode];
  }

  return null;
}
